import React from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import NormalArrowFunction from "../common/NormalArrowFunction";
import { useTranslation } from "react-i18next";
export default function SiteDetails({
  site,
  handleInputChange,
  errors,
  touched,
  handleBlur,
  isUpdating,
  users,
}) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: "8px",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontFamily: "Roboto",
          fontWeight: 500,
          fontSize: "24px",
          lineHeight: "100%",
          letterSpacing: "0%",
          padding: "0px 20px",
          color: "#183059",
        }}
      >
        {t("Site Details")}
      </Typography>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box sx={{ width: "100%" }}>
              <Typography
                variant="body2"
                sx={{ fontSize: "20px", fontWeight: 400, color: "#1F242E" }}
              >
                {t("Site ID")} <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                sx={{
                  mt: "8px",
                  height: "55px",
                  borderRadius: "16px",
                  pt: 0.5,
                  border:
                    touched.siteId && errors.siteId
                      ? "2px solid #d32f2f"
                      : "2px solid #95A0B3",
                  boxShadow:
                    touched.siteId && errors.siteId
                      ? "0 0 0 3px rgba(211, 47, 47, 0.15)"
                      : "none",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
                fullWidth
                required
                name="siteId"
                value={site.siteId}
                onChange={handleInputChange}
                onBlur={() => handleBlur("siteId")}
                error={touched.siteId && Boolean(errors.siteId)}
                helperText={touched.siteId && errors.siteId}
                // disabled={isUpdating}
                placeholder="e.g.SITE123"
                variant="outlined"
                size="small"
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ width: "100%" }}>
              <Typography
                variant="body2"
                sx={{ fontSize: "20px", fontWeight: 400, color: "#1F242E" }}
              >
                {t("Site Name")} <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                sx={{
                  mt: "8px",
                  height: "55px",
                  borderRadius: "16px",
                  pt: 0.5,
                  border:
                    touched.name && errors.name
                      ? "2px solid #d32f2f"
                      : "2px solid #95A0B3",
                  boxShadow:
                    touched.name && errors.name
                      ? "0 0 0 3px rgba(211, 47, 47, 0.15)"
                      : "none",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
                fullWidth
                required
                name="name"
                value={site.name}
                onChange={handleInputChange}
                onBlur={() => handleBlur("name")}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                placeholder="e.g.Main Office"
                variant="outlined"
                size="small"
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ width: "100%" }}>
              <Typography
                variant="body2"
                sx={{ fontSize: "20px", fontWeight: 400, color: "#1F242E" }}
              >
                {t("Site Incharge")}
              </Typography>
              <FormControl
                fullWidth
                sx={{ mt: "8px" }}
                // variant="outlined"
                // size="small"
                error={touched.siteIncharge && Boolean(errors.siteIncharge)}
              >
                <Select
                  id="site-incharge-select"
                  fullWidth
                  displayEmpty
                  variant="standard"
                  disableUnderline
                  name="siteIncharge"
                  SelectDisplayProps={{
                    "aria-label": "Site Incharge",
                  }}
                  IconComponent={({ className, style }) => (
                    <span
                      className={className}
                      style={{
                        ...style,
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                      role="presentation"
                    >
                      <NormalArrowFunction />
                    </span>
                  )}
                  value={site.siteIncharge || ""}
                  onChange={handleInputChange}
                  onBlur={() => handleBlur("siteIncharge")}
                  sx={{
                    height: "55px",
                    borderRadius: "16px",
                    pt: 0.5,
                    border:
                      touched.siteIncharge && errors.siteIncharge
                        ? "2px solid #d32f2f"
                        : "2px solid #95A0B3",
                    boxShadow:
                      touched.siteIncharge && errors.siteIncharge
                        ? "0 0 0 3px rgba(211, 47, 47, 0.15)"
                        : "none",
                    bgcolor: "#fff",
                    // Clip inner layers so white fill cannot cover / break the outer border
                    overflow: "hidden",
                    "& .MuiInputBase-root": {
                      bgcolor: "#fff",
                      borderRadius: "16px",
                      overflow: "hidden",
                    },
                    "& .MuiInput-root": {
                      bgcolor: "#fff",
                      borderRadius: "16px",
                      overflow: "hidden",
                    },
                    "& .MuiSelect-select": {
                      display: "flex",
                      alignItems: "center",
                      // Match TextField size="small" outlined padding (8.5px 14px)
                      py: "8.5px",
                      pl: "14px",
                      pr: "40px",
                      bgcolor: "#fff",
                      // No inner radius — nested radius + white bg was eating the left border
                      borderRadius: 0,
                      // MUI applies rgba(0,0,0,0.05) on :focus — remove grey “inner box”
                      "&:focus": {
                        bgcolor: "#fff",
                      },
                    },
                    // Keep arrow image pointing down (MUI rotates icon 180° when open)
                    "& .MuiSelect-icon": {
                      transform: "none !important",
                    },
                  }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    marginThreshold: 0,
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                      },
                      sx: {
                        mt: 0.5,
                      },
                    },
                  }}
                >
                  <MenuItem value="">
                    <span style={{ color: "#bdbfc2ff" }}>
                      {t("Select Site Incharge")}
                    </span>
                  </MenuItem>
                  {users &&
                    users.map((user) => (
                      <MenuItem key={user.id} value={user.id.toString()}>
                        {user.name}
                      </MenuItem>
                    ))}
                </Select>
                {touched.siteIncharge && errors.siteIncharge && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                    {errors.siteIncharge}
                  </Typography>
                )}
              </FormControl>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Box sx={{ mt: 2, width: "100%" }}>
            <Typography
              variant="body2"
              sx={{ fontSize: "20px", fontWeight: 400, color: "#1F242E" }}
            >
              {t("Description")}
            </Typography>
            <TextField
              sx={{
                mt: "8px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px",
                  border: "2px solid #95A0B3",
                  "& fieldset": {
                    border: "none",
                  },
                },
              }}
              fullWidth
              multiline
              rows={2}
              name="description"
              value={site.description}
              onChange={handleInputChange}
              placeholder="e.g. Main Office near Airport"
              variant="outlined"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
